import { Spacer } from "@hackthenorth/north";
import { Link, Text } from "north.js";
import React from "react";
import styled from "styled-components";

import { Header, PageWrapper } from "src/shared/components";
import { Route } from "src/shared/constants/route";
import { useUserContext } from "src/shared/contexts";

const MentorDashboard: React.FC = () => {
  const { info } = useUserContext();
  const userName = info?.name.split(" ")[0] ?? "Mentor";

  return (
    <>
      <Header title="Mentor Dashboard" />
      <PageWrapper>
        <HeaderText>Hi, {userName}!</HeaderText>

        <Text type="h3">
          Thanks for signing up as a mentor for Hack the North!<br></br>
        </Text>
        <Spacer height={12} />
        <Text>
          Make sure to create your{" "}
          <Link href={Route.MENTOR_PROFILE}>Mentor Profile</Link> and check out{" "}
          <Link href={Route.MENTOR_REQUESTS}>Open Requests</Link> to get
          started.
        </Text>
      </PageWrapper>
    </>
  );
};

const HeaderText = styled.h1`
  color: #000;
  font-family: ${({ theme }) => theme.globalConstants.fontFamily.heading};
  font-size: 34px;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
  margin-bottom: 24px;
`;

export default MentorDashboard;
